"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENT_END_DELAY = exports.DEFAULT_THROTTLE_RATE = void 0;
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

const EVENT_END_DELAY = exports.EVENT_END_DELAY = 100;
const DEFAULT_THROTTLE_RATE = exports.DEFAULT_THROTTLE_RATE = 50;